import React from 'react';

const Footer = (props) => {
	return <div>I see it. I like it. I want it. I got it. Made with 💖 by Sumi. </div>;
};

export default Footer;
